import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

export type PenaltyCalculationParamsSlice = {
  penaltyFrom: Date | null;
  penaltyTo: Date | null;
  changePenaltyFrom: (penaltyFrom: Date) => void;
  changePenaltyTo: (penaltyTo: Date) => void;
};

const initialData = {
  penaltyFrom: null,
  penaltyTo: null,
};

export const createPenaltyCalculationParamsSlice: StateCreator<
  Store,
  [],
  [],
  PenaltyCalculationParamsSlice
> = (set) => ({
  ...initialData,
  changePenaltyFrom: (penaltyFrom) => set({ penaltyFrom }),
  changePenaltyTo: (penaltyTo) => set({ penaltyTo }),
});
